import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { StaffLeaveRequest, StaffLeaveSession } from '@/types/staffLeave';
import type { StaffLeavePayload } from '@/features/institute/staff/schemas/leave.schema';

/**
 * The signed-in person's own leave.
 *
 * No staff id in any path: the server takes the person from the token, so
 * there is nothing here for a client to point at a colleague. Deciding is not
 * offered — nobody decides their own leave — and withdrawing is refused by the
 * server once the office has decided.
 */
export const myLeaveApi = {
  /**
   * A session's balance and every application, the same as the office sees —
   * the current session unless `academicYearUuid` names a past one.
   */
  get: (academicYearUuid?: string) =>
    unwrap(
      apiClient.get<ApiSuccess<StaffLeaveSession>>('/institute/staff-leave/me', {
        params: academicYearUuid ? { academicYearUuid } : undefined,
      }),
    ),

  apply: (payload: StaffLeavePayload) =>
    unwrap(apiClient.post<ApiSuccess<StaffLeaveRequest>>('/institute/staff-leave/me', payload)),

  /** Only while it is still pending. */
  withdraw: (leaveUuid: string) =>
    unwrap(apiClient.delete<ApiSuccess<StaffLeaveRequest>>(`/institute/staff-leave/me/${leaveUuid}`)),
};
